import json from '../../json'

// initial state
const state = {
  status: '',
  todayDelays: {},
  error: ''
}

// getters
const getters = {
  error: state => state.error,
  todayDelays: state => state.todayDelays,
  status: state => state.status
}

const createEmptyDelayCertificate = (areas, timeZones) => {
  const certs = {
    created_at: '',
    areas: []
  }
  areas.forEach(area => {
    const areaCert = {
      area_id: area.area_id,
      have_delay_certificate: false,
      lines: []
    }
    const lines = area.lines
    lines.forEach(line => {
      const lineCert = {
        line_id: line.line_id,
        have_delay_certificate: false,
        delay_certificates: []
      }
      timeZones.forEach(timeZone => {
        const timeZoneCert = {
          time_zone_id: timeZone.time_zone_id,
          delay_certificate_item_type: 'OTHERS',
          delay_certificate: '',
          is_modified: false,
          cellWidth: timeZone.cellWidth
        }
        lineCert.delay_certificates.push(timeZoneCert)
      })
      areaCert.lines.push(lineCert)
    })
    certs.areas.push(areaCert)
  })
  return certs
}

const mergeDelayCertificateJson = (certs, certJson) => {
  certs.created_at = certJson.created_at
  // エリア
  for (let a = 0; a < certs.areas.length; a++) {
    const area = certs.areas[a]
    const foundArea = certJson.areas.filter(a => a.area_id === area.area_id)
    if (foundArea.length > 0) {
      const areaJson = foundArea[0]
      area.have_delay_certificate = areaJson.have_delay_certificate
      // 路線
      for (let l = 0; l < area.lines.length; l++) {
        const line = area.lines[l]
        const foundLine = areaJson.lines.filter(a => a.line_id === line.line_id)
        if (foundLine.length > 0) {
          const lineJson = foundLine[0]
          line.have_delay_certificate = lineJson.have_delay_certificate
          // 遅延証明書
          for (let c = 0; c < line.delay_certificates.length; c++) {
            const cert = line.delay_certificates[c]
            const foundCert = lineJson.delay_certificates.filter(a => a.time_zone_id === cert.time_zone_id)
            if (foundCert.length > 0) {
              const certJson = foundCert[0]
              cert.delay_certificate_item_type = certJson.delay_certificate_item_type
              cert.delay_certificate = certJson.delay_certificate
              cert.is_modified = certJson.is_modified
            }
          }
        }
      }
    }
  }
  return certs
}

// actions
const actions = {
  all ({ commit, state }, [areas, timeZones]) {
    commit('setStatus', '')
    const certs = createEmptyDelayCertificate(areas, timeZones)
    json.get('/today/ope/delay_certificate/delay_certificate_today.json', undefined, true)
      .then(response => {
        const mergedCerts = mergeDelayCertificateJson(certs, response.data)
        commit('setDelays', mergedCerts)
        commit('setStatus', 'init')
      })
      .catch(() => {
        // 当日の遅延証明書項目が空白となったページが表示
        commit('setDelays', certs)
        commit('setStatus', 'init')
      })
  }
}

// mutations
const mutations = {
  setStatus (state, data) {
    state.status = data
  },
  setDelays (state, data) {
    state.todayDelays = data
    state.status = 'init'
  },
  setError (state, response) {
    if (response && response.data && response.data.error) {
      state.error = response.data.error
    } else {
      state.error = 'サーバーに接続できません。'
    }
    state.status = 'error'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/delaycertificatetoday.js